import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';

import './basic-header-layout.scss';
import Header from './components/header';
import Footer from './components/footer';
// header 투명도 없는 layout
const BasicHeaderLayout = () => {
	const pathname = useLocation().pathname;
	const [isOutletLoaded, setIsOutletLoaded] = useState(true);

	useEffect(() => {
		setIsOutletLoaded(true);
	}, []);

	useEffect(() => {
		// 스크롤 복원 로직
		const handleScrollToTop = () => {
			window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
		};

		requestAnimationFrame(() => {
			requestAnimationFrame(handleScrollToTop);
		});
	}, [pathname]);

	return (
		<div className="app-root-basic">
			<Header />
			<Outlet />
			<AnimatePresence>
				{isOutletLoaded && (
					<motion.div
						key={pathname}
						initial={false}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.3 }}
					>
						<Footer />
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default BasicHeaderLayout;
